import { Avatar } from '@mui/material';
import React from 'react';
import { FaWhatsapp } from 'react-icons/fa6';
import { HiPhone } from 'react-icons/hi';
import { MdEmail } from 'react-icons/md';
import { GetPositionsForRecruiterAPIResponse } from 'types';

const CompanyAccountManagers = ({
	accountManagers,
}: {
	accountManagers: GetPositionsForRecruiterAPIResponse['accountManagers'];
}) => {
	return (
		<>
			<div className="px-4 py-3 border-b border-[#C7C9D9] -mx-[3%]">
				<h4 className="text-lg font-[500] text-[#1C1C28]">Your account managers</h4>
				<p className="text-xs font-[400]">Available to assist with any inquiries.</p>
			</div>
			<div className="flex flex-col gap-4 px-[8px] pt-6">
				{accountManagers?.map((am, i) => (
					<div
						key={am.type}
						className="flex gap-3 pb-4 "
						style={{ borderBottom: i == 0 ? '1px solid #C7C9D9' : 'none' }}
					>
						<div>
							<Avatar
								sx={{ width: '48px', height: '48px' }}
								src={am.accountManager?.profile?.profileImageUrl || am.accountManager?.profile?.imageUrl}
							/>
						</div>
						<div>
							<h3 className="text-lg text-[#1C1C28] font-[600] font-inter">{am.accountManager?.name}</h3>
							<div>
								<div className="flex mt-1 items-center gap-[2px]">
									<div
										className="flex gap-[4px] cursor-pointer"
										onClick={() => {
											window.open(`tel:${am.accountManager.phone}`, '_blank');
										}}
									>
										<HiPhone color="#00B7C4" className="cursor-pointer w-[16px] h-[16px]" />
										<p className="font-inter text-[12px] font-[500] leading-[16px] text-[#555770]">
											+91-{am.accountManager.phone}
										</p>
									</div>
									<FaWhatsapp
										onClick={() => {
											window.open(`https://wa.me/${am.accountManager.phone}`, '_blank');
										}}
										color="#00B7C4"
										className="cursor-pointer  w-[16px] h-[16px]"
									/>
								</div>

								<div
									className="flex mt-1 gap-[4px] cursor-pointer"
									onClick={() => {
										window.open(`mailto:${am.accountManager.email}`, '_blank');
									}}
								>
									<MdEmail color="#00B7C4" className="cursor-pointer w-[16px] h-[16px]" />
									<p className="font-inter text-[12px] font-[500] leading-[16px] text-[#555770]">
										{am.accountManager.email}
									</p>
								</div>
							</div>
						</div>
					</div>
				))}
			</div>
		</>
	);
};

export default CompanyAccountManagers;
